/**
 * Localize the catalog's raw enum values for display. Several complex
 * fields are stored as raw tokens ("central", "under_construction",
 * "yoxdur") - showing them verbatim looks unfinished and is wrong for
 * the ru/en locales. Map the known tokens per field; unknown / free-text
 * values (e.g. exterior_material) fall through unchanged.
 */
import type { Locale } from "@/lib/i18n-config";

type Trans = Record<Locale, string>;

const HEATING: Record<string, Trans> = {
  central: { az: "Mərkəzi", ru: "Центральное", en: "Central" },
  autonomous: { az: "Fərdi (avtonom)", ru: "Автономное", en: "Autonomous" },
  combi: { az: "Kombi", ru: "Котёл (комби)", en: "Combi boiler" },
  none: { az: "Yoxdur", ru: "Нет", en: "None" },
};

const DEED: Record<string, Trans> = {
  var: { az: "Var", ru: "Есть", en: "Yes" },
  yoxdur: { az: "Yoxdur", ru: "Нет", en: "No" },
};

const CONSTRUCTION: Record<string, Trans> = {
  under_construction: { az: "Tikilir", ru: "Строится", en: "Under construction" },
  completed: { az: "Tamamlanıb", ru: "Завершён", en: "Completed" },
};

const INTERIOR: Record<string, Trans> = {
  unfinished: { az: "Təmirsiz", ru: "Без ремонта", en: "Unfinished" },
  finished: { az: "Təmirli", ru: "С ремонтом", en: "Finished" },
};

const MAPS: Record<string, Record<string, Trans>> = {
  heating: HEATING,
  deed_status: DEED,
  construction_status: CONSTRUCTION,
  interior_condition: INTERIOR,
};

/** Localized label for a catalog enum value, or the raw value when it
 *  isn't a known token (free-text fields stay as authored). */
export function localizeCatalogValue(
  field: string,
  raw: string | null | undefined,
  locale: Locale,
): string {
  const v = (raw ?? "").trim();
  if (!v) return v;
  const map = MAPS[field];
  const hit = map?.[v.toLowerCase()];
  return hit ? hit[locale] : v;
}
